import { createSelector } from 'reselect';
const getSelectedTabs = state => state.tabs;
export const getSelectedTab = createSelector([getSelectedTabs], selectedTabs => selectedTabs === null || selectedTabs === void 0 ? void 0 : selectedTabs.selectedTab);